<template lang="pug">
  .video-chat__wrapper(
    :class="`video-chat__wrapper--${layoutType}`",
    :style="sidebarWidth",
    :key="layoutType",
    :data-members="members"
  )
    //- タイル
    template(v-if="layoutType === 'tile'")
      .video-wrapper(v-if="!stealth")
        LocalStream
      .video-wrapper(
        v-for="stream in streams",
        :id="stream.peerId"
      )
        OtherStream(:stream="stream")

    //- サイドバー
    template(v-else-if="layoutType === 'sidebar'")
      template(v-if="isSharePeerId")
        .video-wrapper(v-if="peerId === mainStreamPeerId")
          LocalStream
        template(v-for="stream in streams")
          .video-wrapper(
            v-if="stream.peerId === mainStreamPeerId",
            :id="stream.peerId"
          )
            OtherStream(:stream="stream")
      .bg-dark.video-wrapper(v-else)
      .separate-bar(
        @mousedown="updateResizeFlag",
        @touchstart="updateResizeFlag"
      )
      //- サイドバーの右側
      div(:style="{ overflowY: 'scroll' }")
        .video-wrapper.video-wrapper--sidebar(v-if="peerId !== mainStreamPeerId && !stealth")
          LocalStream(@event-changeMainStream="changeMainStream")
        template(v-for="stream in streams")
          .video-wrapper.video-wrapper--sidebar(
            v-if="stream.peerId !== mainStreamPeerId",
            :id="stream.peerId"
          )
            OtherStream(
              :stream="stream",
              @event-changeMainStream="changeMainStream"
            )

    //- スポットライト
    template(v-else-if="layoutType === 'spotlight'")
      .video-wrapper(v-if="peerId === mainStreamPeerId")
        LocalStream
      .video-wrapper(
        v-for="stream in streams",
        :class="{ 'sr-only': stream.peerId !== mainStreamPeerId }",
        :id="stream.peerId"
      )
        OtherStream(:stream="stream")

    //- ポップアップ
    template(v-else-if="layoutType === 'popup'")
      .video-wrapper(v-if="peerId === mainStreamPeerId")
        LocalStream
      .video-wrapper(
        v-for="stream in streams",
        :class="{ 'sr-only': stream.peerId !== mainStreamPeerId }",
        :id="stream.peerId"
      )
        OtherStream(:stream="stream")
      //- ポップアップの小窓部分
      .video-popup(
        v-show="streams.length",
        ref="videoPopup",
        :style="stylePopup"
      )
        .video-popup__header
          button.btn.btn-reset.video-popup__header-button(@click="hidePopupBody")
            img.video-popup__header-icon(src="/static/img/app/btn-window-minimize.svg")
          button.btn.btn-reset.video-popup__header-button(@click="updatePopupSize(210)")
            img.video-popup__header-icon(src="/static/img/app/btn-rectangle-landscape.svg")
          button.btn.btn-reset.video-popup__header-button(@click="updatePopupSize(410)")
            img.video-popup__header-icon(src="/static/img/app/btn-window-maximize.svg")
          input.form-control-rnage.custom-range.video-popup__header-range(
            v-model="popup.range",
            type="range",
            min="30"
          )
        .video-popup__body(
          v-show="popup.show",
          :style="stylePopupBody"
        )
          .video-wrapper.video-wrapper--popup(v-if="peerId !== mainStreamPeerId && !stealth")
            LocalStream(@event-changeMainStream="changeMainStream")
          template(v-for="stream in streams")
            .video-wrapper.video-wrapper--popup(
              v-if="stream.peerId !== mainStreamPeerId",
              :id="stream.peerId"
            )
              OtherStream(
                :stream="stream",
                @event-changeMainStream="changeMainStream"
              )
</template>

<script>
import interact from 'interactjs'
import LocalStream from './LocalStream'
import OtherStream from './OtherStream'

export default {
  name: 'Top',
  components: {
    LocalStream,
    OtherStream
  },
  props: ['streams'],
  data () {
    return {
      sidebar: {
        width: 200,
        min: 200,
        max: 0,
        separateWidth: 10,
        prevClientX: 0,
        prevWidth: 200
      },
      popup: {
        x: 0,
        y: 100,
        w: 210,
        show: true,
        range: 100
      }
    }
  },
  computed: {
    members () {
      return Object.keys(this.$store.state.users).length
    },
    peerId () {
      return this.$store.state.peerId
    },
    layoutType () {
      return this.$store.state.layout.type
    },
    mainStreamPeerId () {
      return this.$store.state.layout.mainStreamPeerId
    },
    isSharePeerId () {
      let flag = this.streams.find(stream => stream.peerId === this.mainStreamPeerId)

      if (!flag) {
        flag = this.peerId === this.mainStreamPeerId
      }

      return flag
    },
    stylePopup () {
      return {
        left: `${this.popup.x}px`,
        top: `${this.popup.y}px`,
        width: `${this.popup.w}px`
      }
    },
    stylePopupBody () {
      return { opacity: (this.popup.range / 100) }
    },
    stealth () {
      return this.$store.state.stealth
    },
    sidebarWidth () {
      if (this.layoutType === 'sidebar') {
        return { 'grid-template-columns': `1fr ${this.sidebar.separateWidth}px ${this.sidebar.width}px` }
      }

      return null
    }
  },
  watch: {
    // レイアウトがポップアップの場合、interactの初期処理をする
    layoutType () {
      if (this.layoutType === 'popup') {
        this.$nextTick(() => this.popupInit())
      }
    }
  },
  mounted () {
    window.addEventListener('mouseup', () => {
      window.removeEventListener('mousemove', this.updateSidebarWidth)
    })
    window.addEventListener('touchend', () => {
      window.removeEventListener('touchmove', this.updateSidebarWidth)
    })
  },
  methods: {
    changeMainStream (peerId) {
      const layout = {
        mainStreamPeerId: peerId
      }

      this.$store.dispatch('updateLayout', { layout })
    },
    updateResizeFlag (e) {
      e.preventDefault()

      this.sidebar.prevClientX = e.clientX || e.touches[0].clientX
      this.sidebar.prevWidth = this.sidebar.width

      // サイドバーの横幅のmax値
      this.sidebar.max = (window.innerWidth / 2.5)

      window.addEventListener('mousemove', this.updateSidebarWidth)
      window.addEventListener('touchmove', this.updateSidebarWidth)
    },
    updateSidebarWidth (e) {
      // テキスト選択されていて、仕切りバーをゆっくり動かすとテキストを移動しようとするのを回避
      e.preventDefault()

      // separate-barクリック時点のカーソルの位置と現在の位置の差を求める
      const clientX = e.clientX || e.touches[0].clientX
      const diff = this.sidebar.prevClientX - clientX

      const targetWidth = diff + this.sidebar.prevWidth

      // maxとminの間でリサイズ可能
      if (targetWidth > this.sidebar.max) {
        this.sidebar.width = this.sidebar.max
        return
      }

      if (targetWidth < this.sidebar.min) {
        this.sidebar.width = this.sidebar.min
        return
      }

      this.sidebar.width = targetWidth
    },
    hidePopupBody () {
      this.popup.show = !this.popup.show
    },
    updatePopupSize (width) {
      this.popup.show = true
      this.popup.w = width
    },
    popupInit () {
      // popupのx軸の初期値
      this.popup.x = window.innerWidth - 400

      const self = this
      const target = this.$refs.videoPopup

      interact(target)
        .resizable({
          edges: {
            left: true,
            right: true,
            bottom: true
          },
          listeners: {
            move (e) {
              self.popup.w = e.rect.width
            }
          },
          modifiers: [
            // 画面外にはみ出るかどうか
            interact.modifiers.restrictEdges({
              outer: 'parent'
            }),
            interact.modifiers.restrictSize({
              // 横に透明のボーダーがあるので、実際は200が最小値となる
              min: { width: 210 }
            })
          ],
          inertia: true
        })
        .draggable({
          listeners: {
            move (e) {
              self.popup.x += e.delta.x
              self.popup.y += e.delta.y
            }
          },
          modifiers: [
            interact.modifiers.restrictRect({
              restriction: 'parent',
              endOnly: true
            })
          ],
          inertia: true
        })
        .ignoreFrom('input, video, button')
    }
  }
}
</script>
